export const HOME_ACTIONS_TYPES = {
	FETCH_HomeData_START: "HOME/FETCH_HomeData_START",
	FETCH_HomeData_SUCCESS: "HOME/FETCH_HomeData_SUCCESS",
	FETCH_HomeData_FAILED: "HOME/FETCH_HomeData_FAILED",
};
